import type React from "react";
import { ReactComponent as Svg } from "./assets/view-1.svg";
import * as styles from "./Icon.module.scss";

type View1Props = React.SVGProps<SVGSVGElement>;

export const View1 = ({ className, ...props }: View1Props) => (
  <Svg className={className ?? styles.base} {...props} />
);
